import script from "./LootBoxMethBoxes.vue?vue&type=script&setup=true&lang=js"
export * from "./LootBoxMethBoxes.vue?vue&type=script&setup=true&lang=js"

import "./LootBoxMethBoxes.vue?vue&type=style&index=0&id=6dd8a6a0&lang=scss"

const __exports__ = script;

export default __exports__